import { render, staticRenderFns } from "./NoStartWindow.vue?vue&type=template&id=46916edd&scoped=true&"
import script from "./NoStartWindow.vue?vue&type=script&lang=js&"
export * from "./NoStartWindow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/windowAkawaku.css?vue&type=style&index=0&id=46916edd&prod&scoped=true&lang=css&"
import style1 from "./NoStartWindow.vue?vue&type=style&index=1&id=46916edd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46916edd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCol,VDialog,VRow})
